__turbopack_context__.v({
  "activity": "AiAssistantPanel-module__xqgWXa__activity",
  "assistant": "AiAssistantPanel-module__xqgWXa__assistant",
  "author": "AiAssistantPanel-module__xqgWXa__author",
  "composer": "AiAssistantPanel-module__xqgWXa__composer",
  "conversation": "AiAssistantPanel-module__xqgWXa__conversation",
  "drawer": "AiAssistantPanel-module__xqgWXa__drawer",
  "empty": "AiAssistantPanel-module__xqgWXa__empty",
  "heading": "AiAssistantPanel-module__xqgWXa__heading",
  "hint": "AiAssistantPanel-module__xqgWXa__hint",
  "inputLabel": "AiAssistantPanel-module__xqgWXa__inputLabel",
  "message": "AiAssistantPanel-module__xqgWXa__message",
  "panel": "AiAssistantPanel-module__xqgWXa__panel",
  "pending": "AiAssistantPanel-module__xqgWXa__pending",
  "settingsLabel": "AiAssistantPanel-module__xqgWXa__settingsLabel",
  "toolbar": "AiAssistantPanel-module__xqgWXa__toolbar",
  "user": "AiAssistantPanel-module__xqgWXa__user",
});
